import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Transition } from 'react-transition-group';

const wrapperStyle = {
  position: 'relative',
  overflow: 'hidden',
};

const defaultStyle = {
  width: '100%',
};

const leftStyles = {
  entering: { transform: 'translateX(-100%)' },
  entered: { transform: 'translateX(0)' },
  exiting: { transform: 'translateX(-100%)', position: 'absolute', top: 0 },
  exited: { transform: 'translateX(-100%)', position: 'absolute', top: 0 },
};

const rightStyles = {
  entering: { transform: 'translateX(100%)' },
  entered: { transform: 'translateX(0)' },
  exiting: { transform: 'translateX(100%)', position: 'absolute', top: 0 },
  exited: { transform: 'translateX(100%)', position: 'absolute', top: 0 },
};

class SteppedView extends Component {
  static propTypes = {
    step: PropTypes.number.isRequired,
    steps: PropTypes.arrayOf(PropTypes.node).isRequired,
    duration: PropTypes.number,
    allowOverflow: PropTypes.bool,
  };

  static defaultProps = {
    duration: 200,
    allowOverflow: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      prevStep: props.step,
    };

    this.animating = false;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.step !== this.props.step) {
      this.setState({ prevStep: prevProps.step });
      this.animating = true;
    }
  }

  render() {
    const { step, steps, duration, allowOverflow } = this.props;
    const { prevStep } = this.state;

    const ws = this.animating || !allowOverflow ? wrapperStyle : {};

    return (
      <div className="w-100" style={ws}>
        {steps.map((s, index) => {
          let style = leftStyles;

          if (index < step) style = leftStyles;
          if (index > step) style = rightStyles;
          if (index === step) {
            if (prevStep < step) style = rightStyles;
            if (prevStep > step) style = leftStyles;
          }

          /* eslint-disable react/no-array-index-key */
          return (
            <Transition
              key={index}
              in={index === step}
              timeout={{ appear: 0, enter: duration, exit: duration }}
              mountOnEnter
              unmountOnExit
              addEndListener={(node, done) => {
                node.addEventListener('transitionend', ev => {
                  if (
                    index === step &&
                    ev.propertyName === 'transform' &&
                    ev.target === node
                  ) {
                    // FIXME: for some reason there are multiple transitionend events so the wrapper styles are removed too soon
                    this.animating = false;
                    this.forceUpdate();
                  }

                  done(ev);
                });
              }}
            >
              {state => {
                return (
                  <div
                    style={{
                      ...defaultStyle,
                      ...style[state],
                      transition: `transform ${duration}ms linear`,
                    }}
                  >
                    {s}
                  </div>
                );
              }}
            </Transition>
          );
        })}
      </div>
    );
  }
}

export default SteppedView;
